import {
  FooterContainer,
  FooterContent,
  FooterDetails,
  FooterLabel,
  FooterTitle,
  FooterValue,
} from "./styled";

interface TotalFooterProps {
  total: number;
  title: string;
  isInvalid?: boolean;
  prefix?: string;
  suffix?: string;
}

export default function TotalFooter({
  total,
  title,
  isInvalid = false,
  prefix = "",
  suffix = "",
}: Readonly<TotalFooterProps>): JSX.Element {
  return (
    <FooterContainer data-testid="total-footer">
      <FooterContent>
        <FooterLabel>Total</FooterLabel>
        <FooterDetails>
          <FooterTitle>{title}</FooterTitle>
          <FooterValue $isInvalid={isInvalid}>
            {prefix}
            {total.toFixed(2)}
            {suffix}
          </FooterValue>
        </FooterDetails>
      </FooterContent>
    </FooterContainer>
  );
}
